import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const FloatingCheckout = () => {
  const { cartItems, totalPrice } = useCart();
  const totalItems = cartItems.length;
  
  if (totalItems === 0) return null;

  return (
    <div className="md:hidden fixed bottom-16 left-0 right-0 z-40 mx-4 pointer-events-none animate-fade-up">
      <div className="bg-[#171717] text-white rounded-none p-2 pr-3 flex items-center justify-between pointer-events-auto border border-white/10 shadow-xl">
        <div className="flex items-center gap-3">
          <div className="border border-white/20 rounded-none w-10 h-10 flex items-center justify-center relative bg-[#171717]">
            <ShoppingCart size={16} strokeWidth={1.5} />
            <span className="absolute -top-1 -right-1 bg-white text-[#171717] text-[8px] font-bold w-4 h-4 rounded-none flex items-center justify-center">
              {totalItems}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-[8px] uppercase tracking-[0.2em] font-body font-light opacity-60">TOTAL VALUE</span>
            <span className="text-xs font-body font-light tracking-wide leading-none">৳{totalPrice}</span>
          </div>
        </div>
        
        <Link 
          to="/checkout"
          className="bg-white text-[#171717] hover:bg-neutral-200 px-5 py-2.5 rounded-none text-[10px] font-body font-light uppercase tracking-[0.2em] transition-all active:scale-98 flex items-center justify-center min-h-[40px]"
        >
          CHECKOUT
        </Link>
      </div>
    </div>
  );
};

export default FloatingCheckout;
